import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { Container } from "@/components/General/Grid/container.component";

type BlockSectionProps = {
    className?: string;
    title: string | ReactNode;
    children: ReactNode;
    iconClass?: string;
};

const BlockSection = ({
    title,
    children,
    iconClass,
    className
}: BlockSectionProps) => {
    return (
        <Container
            as="section"
            className={cn(
                "bg-primary p-4 mb-4 card text-light text-center d-flex flex-column align-items-center",
                className
            )}
        >
            {iconClass && <i className={iconClass} />}
            <h4>{title}</h4>
            {children}
        </Container>
    );
};

export { BlockSection };
